// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"c9e59029","483":"212af68c","709":"7f94c048"}[chunkId] + ".chunk.js";
};